import React from 'react';
import DentoPage from './dento/DentoPage';

export default function Dento() {
  return <DentoPage />;
}
